import { ThemeConfig } from "antd/es/config-provider/context";

import { defaultTheme } from "./index";

export const customTheme: ThemeConfig = {
  token: {
    colorPrimary: defaultTheme.colors.blueDianne,
    colorLink: defaultTheme.colors.blueDianne,
    colorLinkHover: defaultTheme.colors.jungleGreen,
    colorTextHeading: defaultTheme.colors.blueDianne,
    colorPrimaryBgHover: defaultTheme.colors.tiara,
  },
};
